import * as React from 'react';
import { styled, createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import MuiAppBar from '@mui/material/AppBar';
import MuiDrawer from '@mui/material/Drawer';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Badge from '@mui/material/Badge';
import Container from '@mui/material/Container';
import Avatar from "@mui/material/Avatar";
import { useDispatch, useSelector } from "react-redux";
import { ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import Logout from '@mui/icons-material/Logout';
import { logout } from "../redux/actions/userActions";
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { useHistory } from "react-router-dom";
import { GENERAL_ROUTE, PROFILE_ROUTE } from "../routes/const";
import { Home, MarkUnreadChatAlt, AccountCircle, AssignmentOutlined } from '@mui/icons-material';
import { clientContractCRUD } from "../http/CRUD";

const drawerWidth = 240;

const AppBar = styled(MuiAppBar)(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1,
  backgroundColor: '#222328',
}));

const Drawer = styled(MuiDrawer)(({ theme }) => ({
  '& .MuiDrawer-paper': {
    position: 'relative',
    width: drawerWidth,
    backgroundColor: '#222328',
    color: 'white',
    borderRight: 'none',
    boxSizing: 'border-box',
  },
}));

const mdTheme = createTheme({
  palette: {
    primary: {
      main: '#222328',
      contrastText: 'white',
    },
  },
});

const ClientLayout = ({ children }) => {
  const dispatch = useDispatch();
  const { basket } = useSelector((state) => state.basket);
  const history = useHistory();
  const [unsignedCount, setUnsignedCount] = React.useState(0);

  React.useEffect(() => {
    (async () => {
      try {
        const data = await clientContractCRUD.getContracts();
        if (Array.isArray(data)) {
          const count = data.filter(c => !c.signers || c.signers.length <= 1).length;
          setUnsignedCount(count);
        } else if (data?.result && Array.isArray(data.result)) {
          const count = data.result.filter(c => !c.signers || c.signers.length <= 1).length;
          setUnsignedCount(count);
        }
      } catch (e) {
        console.error("Ошибка загрузки контрактов для бейджа:", e);
      }
    })();
  }, []);

  return (
    <ThemeProvider theme={mdTheme}>
      <Box sx={{ display: 'flex', backgroundColor: '#f5f5f5' }}>
        <CssBaseline />

        {/* Верхняя панель */}
        <AppBar position="fixed">
          <Toolbar>
            <Typography variant="h6" noWrap sx={{ flexGrow: 1 }}>
              Национальный центр экспертизы
            </Typography>
            <Avatar sx={{ bgcolor: 'transparent' }}>
              <AccountCircle sx={{ color: '#9e9e9e', fontSize: 34 }} />
            </Avatar>
          </Toolbar>
        </AppBar>

        {/* Статичное меню слева */}
        <Drawer variant="permanent" open>
          <Toolbar />
          <Divider sx={{ backgroundColor: '#444' }} />

          <ListItem disablePadding>
            <ListItemButton onClick={() => history.push(GENERAL_ROUTE + '/')}>
              <ListItemIcon><Home sx={{ color: 'white' }} /></ListItemIcon>
              <ListItemText primary="Главная" />
            </ListItemButton>
          </ListItem>

          <ListItem disablePadding>
            <ListItemButton onClick={() => history.push(GENERAL_ROUTE + '/contracts')}>
              <ListItemIcon><MarkUnreadChatAlt sx={{ color: 'white' }} /></ListItemIcon>
              <ListItemText primary="Контракты" />
              {unsignedCount > 0 && <Badge badgeContent={unsignedCount} color="error" />}
            </ListItemButton>
          </ListItem>

          {/* Новый пункт — История заявок */}
          <ListItem disablePadding>
            <ListItemButton onClick={() => history.push(GENERAL_ROUTE + '/history')}>
              <ListItemIcon><AssignmentOutlined sx={{ color: 'white' }} /></ListItemIcon>
              <ListItemText primary="История заявок" />
            </ListItemButton>
          </ListItem>

          <ListItem disablePadding>
            <ListItemButton onClick={() => history.push(GENERAL_ROUTE + '/basket')}>
              <ListItemIcon><ShoppingCartIcon sx={{ color: 'white' }} /></ListItemIcon>
              <ListItemText primary="Корзина" />
              <Badge badgeContent={basket.length || 0} color="warning" />
            </ListItemButton>
          </ListItem>

          <Divider sx={{ backgroundColor: '#444' }} />

          <ListItem disablePadding>
            <ListItemButton onClick={() => history.push(PROFILE_ROUTE)}>
              <ListItemIcon><AccountCircle sx={{ color: 'white' }} /></ListItemIcon>
              <ListItemText primary="Профиль" />
            </ListItemButton>
          </ListItem>

          <ListItem disablePadding>
            <ListItemButton onClick={() => dispatch(logout())}>
              <ListItemIcon><Logout sx={{ color: 'white' }} /></ListItemIcon>
              <ListItemText primary="Выйти" />
            </ListItemButton>
          </ListItem>
        </Drawer>

        {/* Основной контент */}
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            height: '100vh',
            overflow: 'auto',
            backgroundColor: '#f5f5f5',
          }}
        >
          <Toolbar />
          <Container maxWidth={false} sx={{ mt: 4, mb: 4 }}>
            {children}
          </Container>
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default ClientLayout;
